<p>{{ message }}</p>
<loading-layout #loadingLayoutNothing></loading-layout>
